import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as marked from 'marked';

// Source: https://markrabey.com/2019/05/31/angular-markdown-pipe/

// configure marked to avoid rendering html injected elements

const renderer = new marked.Renderer();
const canDisplayTag = (tag: string) =>
    renderer.br().includes(tag) || renderer.hr().includes(tag) || '<span>'.includes(tag) || '</span>'.includes(tag);

renderer.html = tag => {
    if (canDisplayTag(tag)) {
        return tag;
    }

    return '';
};
marked.setOptions({
    renderer: renderer
});

// If you want to prevent links do this:
// renderer.link = link => {
//     return link;
// };

@Pipe({
    name: 'marked',
    standalone: false
})
export class MarkedPipe implements PipeTransform {
    transform(value: string, parseAsPlainString = false): string {
        if (value) {
            let parsedValue = marked.parse(value);
            parsedValue = this.convertCurrencyDisplay(parsedValue);
            return parseAsPlainString ? this.getPlainString(parsedValue) : parsedValue;
        }

        return value;
    }

    private getPlainString(value: string): string {
        const htmlTagsRegex = /(<([^>]+)>)/gi; //NOSONAR
        const lessThanRegex = /&lt;/g;
        const greaterThanRegex = /&gt;/g;
        const ampersandThanRegex = /&amp;/g;

        return value
            .replace(htmlTagsRegex, '')
            .replace(lessThanRegex, '<')
            .replace(greaterThanRegex, '>')
            .replace(ampersandThanRegex, '&');
    }

    /*
     *  EXAMPLE :
     *  CURR_CODE{{USD}} -> USD
     *  CURR_SYM{{USD}} -> $
     */
    private convertCurrencyDisplay(value: string): string {
        return value
            .replace(/CURR_CODE{{([A-Z]+)}}/g, c => c.slice(11, -2))
            .replace(/CURR_SYM{{([A-Z]+)}}/g, c => getCurrencySymbol(c.slice(10, -2), 'narrow'));
    }
}
